import React, {useEffect, useState} from 'react';
import * as moment from 'moment';
import './ClientDashboard.scss';
import * as _ from "lodash";
import {connect} from "react-redux";
import {toggleAccountPreferencesModal, toggleLoading} from "../../redux/reducers/utils";
import {compose} from "redux";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import DashboardBanner from "../Dashboard/components/DashboardBanner";
import Button from "@material-ui/core/Button";
import {navigate} from "@reach/router";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import VaultCard from "../Dashboard/components/VaultCard";
import FreeTrialCard from "../Dashboard/components/FreeTrialCard";
import ActivityLog from "../Dashboard/ActivityLog/ActivityLog";
import AddClientModal from "./AddClientModal";
import MaterialTable from "material-table";

function ClientDashboard(props) {
  let [clients, setClients] = useState([]);
  let [openAddClientModal, setOpenAddClientModal] = useState(false);
  let [activityLog, setActivityLog] = useState([]);

  useEffect(() => {
    if (props.user) {
      if (props.user.clients && Object.keys(props.user.clients).length) {
        setClients(_.map(Object.keys(props.user.clients), clientKey => props.user.clients[clientKey]))
      }
      props.toggleLoading(true);
      // routes.e().subscribe((response) => {

        // const vaults = response.data.map((vault) => {
        //   // format vault dates & display values
        //   vault['lastUpdated'] = moment(vault.updated).format('MM-DD-YYYY');
        //   vault['purposeDisplay'] = purposeMapping[vault['purpose']];
        //
        //   _.forEach(vault["activity_log"], (activity) => {
        //     activity.vaultName = vault.vault_name;
        //     activity.vaultId = vault.id;
        //   });
        //
        //   return vault;
        // });

        // setActivityLog(_.orderBy(_.flatten(_.map(vaults, 'activity_log')), (x) => moment(x.created), ['desc']));
      // });
      props.toggleLoading(false);

    }
  }, [props.user]);


  return (
    <div className="flex-1 client-dashboard">
      <AddClientModal openModal={openAddClientModal} closeModal={() => setOpenAddClientModal(false)}/>
      <div className="full-size dashboard-container mx-auto">
        {/*<DashboardBanner user={props.user}/>*/}
        <div className="flex flex-col lg:flex-row justify-center">
          <div className="vaults-container lg:mr-8 mb-6 lg:mb-0">
            <Paper className="w-full">
              <div className="sm:flex sm:items-center">
                <div className="vaults-description-container text-left">
                  <p className="medium-text">My Clients</p>
                </div>
                <div className="vaults-top-divider mt-3 mb-5 sm:mt-0 sm:mb-0"/>
                <div className="sm:ml-6">
                  <Button
                    variant="contained"
                    className="w-full sm:w-auto"
                    onClick={() => setOpenAddClientModal(true)}
                    color="primary">
                      <span className="flex items-center">
                        <FontAwesomeIcon icon="plus" className="mr-2"/>
                        <p>Add New Client</p>
                      </span>
                  </Button>
                </div>
              </div>

              {
                props.user &&
                  <>
                    {
                      !!!clients.length === 0 &&
                      <div className="flex items-center text-center justify-center missing-other-vaults">
                        <div className="mt-3">
                          <p className="text-grey text-xl">No Clients Found.</p>
                          <p className="text-grey text-sm mt-3 md:text-base">New to Fidelius? View our <a target="_blank" href={"https://www.fideliusvaults.com/faq/"}>FAQ</a> and <a target="_blank" href={"https://www.fideliusvaults.com/how-it-works/"}>How It Works</a> pages for more information.</p>
                        </div>
                      </div>
                    }
                    {
                      !!clients.length &&
                      <div className="">
                        <MaterialTable
                          title=""
                          columns={[
                            { title: 'Name', field: 'name',
                              render: rowData => <a onClick={() => navigate(`/clients/${rowData.id}`)}>{rowData.name}</a>
                            },
                            { title: 'Documents Received?',
                              field: 'pending_documents',
                              render: rowData => <span>{rowData.pending_documents ? 'No' : 'Yes'}</span>
                            },
                            { title: 'Vaults',
                              field: 'vaults',
                              render: rowData => <span>{rowData.vaults.length}</span>
                            },
                            { title: 'Last Updated', field: 'updated',
                              render: rowData => <span>{moment(rowData.updated).format('MM-DD-YYYY')}</span>
                            },
                          ]}
                          data={clients}
                          options={{
                            filtering: false
                          }}
                        />
                      </div>
                    }
                  </>
              }




            </Paper>
          </div>

          <div className="dashboard-sidebar-container">
            <FreeTrialCard user={props.user} toggleAccountPreferencesModal={props.toggleAccountPreferencesModal}/>
            <ActivityLog activityLog={activityLog}/>
          </div>
        </div>

      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    user: state.user.user,
  };
};

export default compose(
  connect(
    mapStateToProps,
    { toggleLoading, toggleAccountPreferencesModal }
  )
)(ClientDashboard);
